import { useQuery } from '@tanstack/react-query';
import { useApi } from '../../providers/ApiProvider';

export function useBusinessMerchant({
  page = 1,
  perPage = 10,
  search = '',
  filter_verified,
  enabled = true,
  created_at = '',
}: {
  page?: number;
  perPage?: number;
  search?: string;
  filter_verified?: string;
  enabled?: boolean;
  created_at?: string;
}) {
  const api = useApi();

  return useQuery({
    queryKey: ['business-merchant', search, filter_verified, page, created_at], 
    queryFn: async () => {
      const res = await api.GET({
        endpoint: 'business-merchant',
        params: { page, per_page: perPage, search, filter_verified, created_at },
      });
      return res;
    },
    enabled,
  });
}
